export class scrollSidebarAddClass {
	// static sidebarAnchors = $(".anchor--sidebar");

	// static handleScroll(windowObject) {
	// 	const scrollTop = windowObject.scrollTop();
	// 	const thisSidebarAnchors = this.sidebarAnchors;
	// 	thisSidebarAnchors.each(function () {
	// 		const anchor = $(this);
	// 		if (anchor.attr("href").includes("#")) {
	// 			const targetHref = anchor.attr("href");
	// 			const target = $(targetHref.substring(targetHref.indexOf("#")));
	// 			if (target.length && target.offset().top <= scrollTop) {
	// 				thisSidebarAnchors.removeClass("current");
	// 				anchor.addClass("current");
	// 			}
	// 		}
	// 	});
	// }

	sidebarAnchors = $('.anchor--sidebar')

	constructor() {
		$(window).on('scroll', () => {
			const scrollTop = $(window).scrollTop()
			const thisSidebarAnchors = this.sidebarAnchors
			thisSidebarAnchors.each(function () {
				const anchor = $(this)
				if (anchor.attr('href').includes('#')) {
					const targetHref = anchor.attr('href')
					const target = $(targetHref.substring(targetHref.indexOf('#')))
					if (target.length && target.offset().top <= scrollTop) {
						thisSidebarAnchors.removeClass('current')
						anchor.addClass('current')
					}
				}
			})
		})
	}
}
